<template>
  <div class="wei-block  bg-white mt-4 w-100">
    <div class="product-item ">
      <div class="item-title text-center py-4">{{title}}</div>
      <div class="item-content container" v-if="zhuanlanList">
        <div class="d-block mb-4" v-for="item in zhuanlanList" :key="item.id">
          <van-card class="wei-item mt-0" @click="goPage(item)">
            <template #thumb>
              <div v-if="item.imageUrl" class="zhuanlan-logo flex-1 mr-3"
                   :style="{'background-image':'url('+uploadresUrl+item.imageUrl+')'}">
              </div>
            </template>
            <template #title>
              <div class="wei-item-title van-multi-ellipsis--l2">
                {{item.title}}
              </div>
            </template>
            <template #desc>
              <div class="mt-3">
                {{item.publishedTime | dateFormat}}
              </div>
            </template>
          </van-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Card} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Card);

  export default {
    name: "zhuanlanComponent",
    data() {
      return {

      }
    },
    props: [
      'zhuanlanList',
      'title'
    ],
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        ContentTypeEnum: state => state.ContentTypeEnum
      })
    },
    mounted() {

    },
    methods: {
      goPage(item) {
        if (item.contentType === this.ContentTypeEnum.PROJECT.value
          || item.contentType === this.ContentTypeEnum.COURSE.value) {
          this.$router.push('/'+item.contentType+'/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.USER.value) {
          this.$router.push('/lecturer/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.NEWS.value) {
          this.$router.push('/news-detail/'+item.id);
        }
        if (item.contentType === this.ContentTypeEnum.LINK.value) {
          window.open(item.linkUrl);
        }

      }
    }
  }
</script>

<style scoped>

</style>
